// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgScreenChange24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M22 5C22 3.89543 21.1046 3 20 3H4C2.89543 3 2 3.89543 2 5V16C2 17.1046 2.89543 18 4 18H8.25V20C8.25 20.9665 9.0335 21.75 10 21.75H14C14.9665 21.75 15.75 20.9665 15.75 20V18H20C21.1046 18 22 17.1046 22 16V5ZM9.75 18H14.25V20C14.25 20.1381 14.1381 20.25 14 20.25H10C9.86193 20.25 9.75 20.1381 9.75 20V18ZM20 4.5H4C3.72386 4.5 3.5 4.72386 3.5 5V16C3.5 16.2761 3.72386 16.5 4 16.5H20C20.2761 16.5 20.5 16.2761 20.5 16V5C20.5 4.72386 20.2761 4.5 20 4.5ZM10.6029 13.9462C10.8208 13.6526 10.7966 13.2359 10.5303 12.9697L8.81 11.249H15.189L13.4697 12.9697C13.2034 13.2359 13.1792 13.6526 13.3971 13.9462L13.4697 14.0303C13.7626 14.3232 14.2374 14.3232 14.5303 14.0303L17.5303 11.0303L17.5988 10.9516L17.6212 10.9203L17.6531 10.869L17.6884 10.7981L17.711 10.7393L17.7303 10.6714L17.7482 10.5515L17.7482 10.4486L17.7376 10.3637L17.7112 10.2613L17.6761 10.1748L17.6215 10.0799L17.5659 10.0078L17.5303 9.96967L14.5303 6.96967C14.2374 6.67678 13.7626 6.67678 13.4697 6.96967L13.3971 7.05379C13.1792 7.3474 13.2034 7.76406 13.4697 8.03033L15.189 9.749H8.812L10.5303 8.03033C10.8232 7.73744 10.8232 7.26256 10.5303 6.96967C10.2374 6.67678 9.76256 6.67678 9.46967 6.96967L6.46967 9.96967C6.17678 10.2626 6.17678 10.7374 6.46967 11.0303L9.46967 14.0303C9.76256 14.3232 10.2374 14.3232 10.5303 14.0303L10.6029 13.9462Z"
				/>
			</Svg>
		);
	}
);
SvgScreenChange24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgScreenChange24;
